import { Toast as Toast } from 'bootstrap';
import { generator } from '../helpers/helpers';

/**
 * Function that displays a toast message
 * 
 * @param {string} cssClass the css class to apply to the toast
 * @param {string} toastMessage the message to display in the toast
 * 
 * @returns void
 */
export const showToast = (cssClass: string, toastMessage: string) => {
  const toastContainer = document.querySelector('.aafp_toast-container') as HTMLElement;

  let gen = generator();
  let toastID = gen.next().value;

  const toastEl = document.createElement('div');
  toastEl.classList.add('toast', cssClass, `show${toastID}`);
  toastEl.setAttribute('role', 'alert');
  toastEl.setAttribute('aria-live', 'assertive');
  toastEl.setAttribute('aria-atomic', 'true');
  toastEl.innerHTML = `
        <div class="aafp_toast-header">
          <img src="/wp-content/uploads/2021/07/AllianceSymbol.png" class="" alt="Alliance Autogas Fueling Portal">
          <strong class="">Alliance Autogas Fueling Portal</strong>
          <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close">X</button>
        </div>
        <div class="toast-body">
          ${toastMessage}
        </div>`;

  toastContainer.appendChild(toastEl);

  const toast = new Toast(toastEl, {
    autohide: true,
    delay: 6000
  });
  toast.show();
}